<template>
  <div>
    <header class="header-main">
      <div class="containers" v-if="!$route.meta.hideHeader">
        <a v-show="!!$route.meta.displayBackButton" class="back_btn_action" style="cursor:pointer"
           @click.prevent="navigateToCorrectPath()">
          <img src="static/images/back_btn.svg" alt="">
        </a>
        <router-link to="/home" :class="[getActiveTabClass('/home'), 'logo-header with_back']">
          <img :src="getTranslations.project_logo_img" alt="">
        </router-link>
        <nav class="main-nav main-nav--home">
          <ul :class="['main-nav__list', (hideStore)? 'nav_nostore': '']">
            <li class="chat_menu" v-if="getMessagingConfig.messagingEnabled && chatEnabled">
              <a class="" style="cursor:pointer" @click.prevent="goToChatHistory()">
                <img src="static/images/chat/chat_bubble_white.svg" alt="">
              </a>
            </li>
            <li><a class="icon-bubble" style="cursor:pointer" @click.prevent=goToNotifications><img
              src="static/images/bell-icon.svg" alt="">
              <span v-if="numberOfUnreadNotifications > 0">{{ numberOfUnreadNotifications }}</span></a>
            </li>
          </ul>
          <button data-menu="nav_dropdown" class="nav__toggle nav__toggle--home"><span></span></button>
          <div id="nav_dropdown" class="nav-dropdown">
            <ul class="mobile-menu__list">
              <li class="mobile-menu__item">
                <router-link to="/home/profile" style="cursor:pointer" :class="['mobile-menu__link', getActiveTabClass('/home/profile')]">
                  {{ getTranslations.home_home_profile }}
                </router-link>
              </li>
              <li v-if="!hideStore" class="mobile-menu__item">
                <router-link to="/home/store" style="cursor:pointer" :class="['mobile-menu__link', getActiveTabClass('/home/store')]">
                  {{ getTranslations.home_store_store }}
                </router-link>
              </li>
              <li v-if="!hideLeaderboard" class="mobile-menu__item">
                <router-link to="/home/prizesAndLeaderBoards" :class="['mobile-menu__link', getActiveTabClass('/home/prizesAndLeaderBoards')]">
                  {{ getTranslations.home_home_prizes_and_leaderboards }}
                </router-link>
              </li>
              <li v-if="!hideWinners" class="mobile-menu__item">
                <router-link to="/home/winners" :class="['mobile-menu__link', getActiveTabClass('/home/winners')]">
                  {{ getTranslations.home_home_winners }}
                </router-link>
              </li>
              <li class="mobile-menu__item">
                <router-link to="/home/howitworksLoggedIn" :class="['mobile-menu__link', getActiveTabClass('/home/howitworksLoggedIn')]">
                  {{ getTranslations.home_home_how_it_works }}
                </router-link>
              </li>
              <li v-if="checkIfTranslationEmptyByOrdinal('home_home_daily_fact_text')" class="mobile-menu__item">
                <a style="cursor:pointer" :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_home_daily_fact_url')" target="_blank" class="mobile-menu__link">
                  {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_home_daily_fact_text') }}</a>
              </li>
              <li v-if="userStatusHome && hasSubUnSubOption()" class="mobile-menu__item">
                <a style="cursor: pointer" @click.prevent="subUnSubUser()">{{ userStatusHome.toUpperCase() }}
                </a>
              </li>
              <li v-if="logoutEnable()" class="mobile-menu__item last" >
                <a style="cursor:pointer" class="mobile-menu__link" @click.prevent="logout">
                  {{ getTranslations.home_home_log_out }}</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>

    <router-view :playGame="playGame"></router-view>

    <!-- dynamically change modals -->
    <fade-transition>
      <home-screen-shortcut v-if="shortCutModalEnable() && !homeScreenModalDisable && !serverUnderMaintenance" @cancel="closeModalForHomeScreen()" @ok="successInstall()"></home-screen-shortcut>
    </fade-transition>
    <fade-transition>
      <component v-if="homeScreenModalDisable" :is="modalForHomePage" @close="closeModalValidationsForHome"></component>
    </fade-transition>
    <fade-transition>
      <component  v-if="homeScreenModalDisable &&!activeAddOnMiniGame" :is="modalForChallenge" @close="closeModalValidationsForChallenge"></component>
    </fade-transition>
    <fade-transition>
      <maintenance v-if=serverUnderMaintenance></maintenance>
    </fade-transition>
    <fade-transition>
      <pre-game-lanterns v-if="!serverUnderMaintenance && homeScreenModalDisable  && !modalForChallenge && !modalForHomePage && lanternGame && !showThankYouEmailModal"></pre-game-lanterns>
    </fade-transition>
    <fade-transition>
      <pre-game-add-on-puzzle v-if="!serverUnderMaintenance && homeScreenModalDisable && !modalForChallenge && !modalForHomePage && puzzleGame && !showThankYouEmailModal"></pre-game-add-on-puzzle>
    </fade-transition>
    <fade-transition>
      <email-success v-if="!serverUnderMaintenance && homeScreenModalDisable  && !modalForChallenge && !modalForHomePage && showThankYouEmailModal"></email-success>
    </fade-transition>
    <modal-idle v-if="isIdle"></modal-idle>
    <PleaseWaitInit v-if="!isLoading || needLoad"></PleaseWaitInit>
    <PleaseRefresh v-if="openModalForRefresh"></PleaseRefresh>

    <subscribe-reoptin
      v-if="subscribeReoptimModalConfig.open"
      @proceed="handleSubscribeReoptinProceed"
      @close="handleCloseSubscribeReoptinModal"
    ></subscribe-reoptin>

    <simplify-registration
      v-if="subscriptionViaSmsModalConfig.open"
      :text-key="subscriptionViaSmsModalConfig.textKey"
      @close="handleCloseSubscriptionViaSmsModal"
    ></simplify-registration>

  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }], curly: [2, "multi"] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import { handleBurgerButton, closeTab } from '@/common/jQuery';
import { ParseResponseMixin } from '@/common/mixins/game';
import NewGameMixin from '@/common/mixins/home';
import OnlineUsersMixin from '@/common/mixins/onlineusers/onlineusers';
import GameMixin from '@/common/mixins/game/gameClient';
import { RematchMixin, BeforeDestroyRematch } from '@/common/mixins/rematch/rematch';
import RoundUpMixin from '@/common/mixins/roundUp';
import Maintenance from '@/components/home/modals/shared/Maintenance';
import PleaseWaitInit from '@/components/home/game/PleaseWaitInit';
import RequestForRematch from '@/common/mixins/extraRematchInfo';
import webSocket from '@/common/webSocket';
import { listenForPushNotifications } from '@/common/serviceWorkers';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import ResumeGame from './modals/ResumeGame';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import Unsubscribe from './modals/Unsubscribe';
import UnsubscribeSms from './modals/UnsubscribeSms';
import ResubscribeRequestSettings from './modals/ResubscribeRequestSettings';
import ResubscribeQuestionViaSms from './modals/ResubscribeQuestionViaSms';
import ZeroBalance from './modals/ZeroBalance';
import WelcomeSignup from './modals/WelcomeSignup';
import ModalIdle from '../../ModalIdle';
import BonusDaily from './modals/bonus_phases/BonusDaily';
import PleaseRefresh from './game/PleaseRefresh';
import PendingChallenge from './game/challenge/PendingChallenge';
import PreGameLanterns from './game/addongamelanterns/modals/PreGameLanterns';
import PreGameAddOnPuzzle from './game/addongamepuzzle/PreGameAddOnPuzzle';
import HomeScreenShortcut from './modals/HomeScreenShortcut';
import EmailSuccess from './modals/profile/EmailSuccess';
import SimplifyRegistration from './modals/flow/SimplifyRegistration.vue'
import SubscribeReoptin from './modals/SubscribeReoptin.vue'
import subscriptionMixin, {subscriptionOperationEnum} from '../../common/mixins/subscription'

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'home',
  components: {
    HomeScreenShortcut,
    PleaseRefresh,
    PleaseWaitInit,
    ModalIdle,
    Maintenance,
    FadeTransition,
    PreGameLanterns,
    PreGameAddOnPuzzle,
    EmailSuccess,
    SubscribeReoptin,
    SimplifyRegistration,
  },
  mixins: [OnlineUsersMixin, ParseResponseMixin, NewGameMixin, RoundUpMixin, RematchMixin, RequestForRematch, BeforeDestroyRematch, GameMixin, subscriptionMixin],
  data() {
    return {
      jsonData: null,
      installPromptEvent: null,
      openModalForRefresh: false,
      timeOutAlreadyHasStarted: false,
      userStatusHome: null,
      stompClient: null,
      subscription: null,
      connectionTimer: null,
      currentTabPath: null,
      newButtonClicked: false,
      showedModal: false,
      onlineSubscription: null,
      homeScreenModalApplied: null,
      homeScreenModalDenied: null,
      homeScreenModalEnable: true,
      subscribeReoptimModalConfig: {open: false},
      subscriptionViaSmsModalConfig: {open: false, text: undefined}
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.currentTabPath === null && to.path === '/home') {
        vm.currentTabPath = to.path;
        sessionStorage.setItem('homeCurrentTabPath', vm.currentTabPath);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    console.log(`-------------------------------------- beforeRouteUpdate: ${this.currentTabPath} + ${sessionStorage.getItem('homeCurrentTabPath')} + ${to.path} `);
    sessionStorage.setItem('homeCurrentTabPath', to.path);
    this.storeModalForHomePage(null);
    closeTab();
    this.newButtonClicked = false;
    next();
  },
  created() {
    // eslint-disable-next-line
    if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name && (sessionStorage.getItem('isRun') === null || sessionStorage.getItem('isRun') === 'false')) {
      if (document.getElementById('db_response')) {
        document.removeChild('korek_response');
        document.removeChild('db_response');
      }
      sessionStorage.setItem('isRun', 'true');
    }
    listenForPushNotifications();
    this.setToDefaultChallengeInfo();
    this.rematchWithSpecificUser();
    this.onlineUsersMixin();
    // create also a stomp client for game (challenges for mobiles are too slow)
    this.initGameDataMixin();
    this.getUserStatus();
    if (this.verification.checkId && this.verification.email) {
      const payload = {
        email: this.verification.email,
        checkId: this.verification.checkId,
      };
      this.validateEmail({ verification: payload });
    }
    console.log(`-------------------------------------- created hook: ${this.currentTabPath} `);
    console.log('Home\'s created hook');
    console.log('this.userDetails:', this.userDetails);
    // this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.getUserAchievements();
    this.loadManifest();
    this.homeScreenModalApplied = localStorage.getItem('homeScreenModalApplied');
    this.homeScreenModalDenied = sessionStorage.getItem('homeScreenModalDenied');
    if (this.homeScreenModalApplied || this.homeScreenModalDenied || this.userDetails.hasPhoneShortcut) this.storeHomeScreenModalDisable(true);
  },
  beforeDestroy() { // do not user this hook if you want something after update hook
    if (this.notificationSubscription)
      this.notificationSubscription.unsubscribe();
    if (this.onlineSubscription)
      this.onlineSubscription.unsubscribe();
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', this.beforeInstallPromptHandler);
    console.log(`-------------------------------------- Mounted hook: ${this.userDetails.availableGames}`);
    this.$nextTick(() => {
      handleBurgerButton(ZeroBalance);
    });
    this.autoCheckIfGameToResumeExists();
    this.fetchFavoriteUsers();
    console.log('EVENT AFTER THIS:', this.getInstallPromptEvent);
  },
  updated() {
    this.getUserStatus();
    // eslint-disable-next-line
    // console.log('Username from db: ' + this.userDetails.username + ' username from Storage: ' + localStorage.getItem('username')
    //   + ' jwtToken From LocalStorage: ' + localStorage.getItem('jwtToken')
    //   + ' jwtToken From SessionStorage' + sessionStorage.getItem('jwtToken'));
    if (this.userDetails.username !== '') {
      // eslint-disable-next-line
      console.log('Home.js for skip refresh case');
      if (!((localStorage.getItem('username') === this.userDetails.username))
        && (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') === null)) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users...');
        // eslint-disable-next-line
        window.location.reload();
      }
      if (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') !== null) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users LOCAL & STORAGE...');
        sessionStorage.clear();
        // eslint-disable-next-line
        window.location.reload();
      }
    }

    // eslint-disable-next-line
    console.log('update hook'); // here update hook happens after before destroy hook (beforeDestroy Home -> beforeDestroy rematch js -> update Home)
    if (this.stompClientForOnlineUsers.connected)
      this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: !this.isIdle });
  },
  methods: {
    ...mapMutations('common', [
      'storeUserAvailableGames',
      'storeModalForHomePage',
      'storeModalForChallenge',
      'setInstallPromptEvent',
      'storeHomeScreenModalDisable',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
      'setFirstTimeEntry',
      'clearAllData',
    ]),
    ...mapMutations('game', [
      'setToDefaultChallengeInfo',
      'storeRegistrationPoints',
    ]),
    ...mapActions('users', [
      'fetchFavoriteUsers',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'getUserNotifications',
      'validateEmail',
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
      'getBonusPhases',
      'getUserAchievements',
    ]),
    async loadJsonData() {
      try {
        const response = await axios.get('/static/manifest.json');
        this.jsonData = response.data;
        console.log('RESPONSE DATA', this.jsonData);
        this.createLink();
      } catch (error) {
        console.error('Error loading JSON data:', error);
      }
    },
    loadManifest() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const link = document.createElement('link');
        link.rel = 'manifest';
        const data = this.getTranslations.home_manifest_file_path ? `static/${this.getTranslations.home_manifest_file_path}/manifest.json` : 'static/duel_manifest/manifest.json';
        link.href = data; // Update the path accordingly
        console.log('MANIFEST PATH: ', data);
        document.head.appendChild(link);
        // this.loadJsonData();
      }
    },
    createLink() {
      const manifestData = this.jsonData;
      manifestData.name = this.getTranslations.home_manifest_file_title;
      manifestData.short_name = this.getTranslations.home_manifest_file_title;
      manifestData.icons[0].src = this.getTranslations.home_manifest_file_image1;// Assuming the first icon is being changed
      manifestData.icons[1].src = this.getTranslations.home_manifest_file_image2;
      // Create a new JSON string with the modified data
      const modifiedManifestJson = JSON.stringify(manifestData);
      // Create a Blob from the modified JSON
      const blob = new Blob([modifiedManifestJson], { type: 'application/json' });
      console.log('BLOB', blob);
      // Create a URL for the Blob
      const manifestBlobUrl = URL.createObjectURL(blob);
      console.log('manifestBlobUrl', manifestBlobUrl);
      // Create a link element to add to the head
      // const manifestLink = document.createElement('link');
      // manifestLink.rel = 'manifest';
      // manifestLink.href = manifestBlobUrl;
      // Find the existing link element for the manifest
      const manifestLink = document.querySelector('link[rel="manifest"]');
      // Update the href attribute of the link element
      manifestLink.href = manifestBlobUrl;
      // Append the link element to the head
      document.head.appendChild(manifestLink);
    },
    beforeInstallPromptHandler(event) {
      event.preventDefault();
      // Store the event to prompt the user later
      console.log('EVENT', event);
      sessionStorage.setItem('shortCutEvent', event);
      this.setInstallPromptEvent(event);
    },
    /* eslint-disable */
    shortCutModalEnable() {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        // The PWA is installed
        console.log('PWA is installed');
        this.storeHomeScreenModalDisable(true);
        return false;
      }
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        console.log('not a mobile');
        this.storeHomeScreenModalDisable(true);
        return false;
      }
      if (this.phoneShortcutEnabled) return this.homeScreenModalApplied === 'true' ? false : !(this.homeScreenModalDenied === 'true');
      this.storeHomeScreenModalDisable(true);
      return false;
    },
    /* eslint-enable */
    logoutEnable() {
      if (this.getIntegrationConfig.integrationKey === 'mtn_rsa_he' && this.userDetails.operatorName === 'VODACOM_ZAF') return false;
      return true;
    },
    checkIfTranslationEmptyByOrdinal(key) {
      if (!this.multiOperatorInfo.multiOperatorEnabled) return !!this.getTranslations[key];
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, key);
    },
    navigateToCorrectPath() {
      if (this.$router.currentRoute.path === '/home/store')
        this.$router.push({ name: 'homeDefault' });
      else
        this.$router.push({ name: 'profileDefault' });
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
    goToChatHistory() {
      this.$router.push({ name: 'chat-history' });
    },
    closeModalValidationsForHome() {
      if (this.firstTimeEntry) {
        this.setFirstTimeEntry(false);
        this.methodForPopUps();
      } else this.storeModalForHomePage(null);
    },
    closeModalValidationsForChallenge() {
      this.storeModalForChallenge(null);
      this.setToDefaultChallengeInfo();
    },
    closeModalForHomeScreen() {
      sessionStorage.setItem('homeScreenModalDenied', 'true');
      this.storeHomeScreenModalDisable(true);
    },
    successInstall() {
      this.storeHomeScreenModalDisable(true);
    },
    subUnSubUser() {
      // user is subscribed
      /* eslint-disable */
      if (this.userDetails.subscribed) {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'OPTOUT_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForHomePage(UnsubscribeSms);
          } else {
            this.storeModalForHomePage(Unsubscribe);
          }
        } else {
          this.storeModalForHomePage(Unsubscribe);
        }
      }
      else {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForHomePage(ResubscribeQuestionViaSms);
          } else {
            this.storeModalForHomePage(ResubscribeRequestSettings);
          }
        } else {
          this.storeModalForHomePage(ResubscribeRequestSettings);
        }
      }
      /* eslint-enable */
    },
    getUserStatus() {
      if (!this.userDetails.subscribed)
        this.userStatusHome = '';
      else
        this.userStatusHome = this.getTranslations.home_settings_unsubscribe;
    },
    autoCheckIfGameToResumeExists() {
      this.checkIfGameToResumeExists().then(() => {
        if (this.gameInProgress) {
          this.storeModalForHomePage(ResumeGame);
          console.log('showing resume game pop up...');
        } else if (this.challengePending) {
          this.storeModalForHomePage(PendingChallenge);
          console.log('showing pending challenge modal...');
        } else this.methodForPopUps();
      }).catch(error => console.error(error));
    },
    methodForPopUps() {
      /* eslint-disable */
      if (this.firstTimeEntry) {
        this.storeModalForChallenge(WelcomeSignup); // because if we put it in store_modal_home, we dont want to see the before prize modal (with streaks) again and after welcome
      } else {
        const nowDate = new Date(moment().format('L'));
        const latestLogin = new Date(sessionStorage.getItem('zeroBalancePopUp'));
        if (((nowDate.getTime() > latestLogin.getTime()) || sessionStorage.getItem('zeroBalancePopUp') === null) && (this.userDetails.availableGames === 0 && this.userDetails.subscribed )&& (sessionStorage.getItem('homeCurrentTabPath') === '/home')) {
          this.storeModalForHomePage(ZeroBalance);
          sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
        }
        if (!this.userDetails.subscribed && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              if (this.isRegistrationViaSms) {
                this.subscribeReoptimModalConfig.open = true
              } else {
                this.storeModalForHomePage(ResubscribeGameSms);
              }
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
          } else {
            this.storeModalForHomePage(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames !== 0) this.storeModalForHomePage(null);
      }
      /* eslint-enable */
    },
    goToProfilePage() {
      this.$router.push('/home/profile');
    },
    closeAllStompClients() {
      if (this.onlineSubscription) this.onlineSubscription.unsubscribe();
      if (this.notificationSubscription) this.notificationSubscription.unsubscribe();
      webSocket.disconnectChatStompClient();
      webSocket.disconnectOnlineStompClient();
      webSocket.disconnectNotificationsStompClient();
      webSocket.disconnectGameStompClient();
    },
    goToNotifications() {
      this.$router.push('/home/notifications');
    },
    logout() {
      this.closeAllStompClients();
      this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: false });
      this.storeRegistrationPoints({
        freeGamePrize: null,
      });
      let currentLocale = localStorage.getItem('locale');
      if (currentLocale === undefined || currentLocale === null)
        currentLocale = this.getLocale;
      const soundsOn = localStorage.getItem('soundsOn');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      sessionStorage.clear();
      if (this.userDetails.availableGames === 0)
        sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      this.clearAllData();
      this.$router.push('/');
    },
    doAsyncCallsAfterLoadingAllComponents() {
      this.getBonusPhases().then(() => {
        this.getUserNotifications();
        if (this.bonusDailyModal)
          this.storeModalForHomePage(BonusDaily);
      });
    },
    initRefreshPage() {
      if (this.timeOutAlreadyHasStarted) return false;
      setTimeout(() => {
        if (!this.stompClientForNotifications.connected || !this.stompClientForOnlineUsers.connected) this.openModalForRefresh = true;
        else this.timeOutAlreadyHasStarted = false;
      }, 70000); // after 70 seconds without stomp connection display "Network Error" page
      this.timeOutAlreadyHasStarted = true;
      return false;
    },
    handleSubscribeReoptinProceed(subscriptionType) {
      this.handleCloseSubscribeReoptinModal()

      this.$nextTick(()=>{
        this.subscriptionMixinLaunchAction(
          subscriptionOperationEnum.RESUBSCRIBE,
          subscriptionType,
          value => {
            this.subscriptionViaSmsModalConfig.open = true
            this.subscriptionViaSmsModalConfig.textKey = value
          }
        )
      })
    },
    handleCloseSubscribeReoptinModal() {
      this.subscribeReoptimModalConfig.open = false
    },
    handleCloseSubscriptionViaSmsModal() {
      this.subscriptionViaSmsModalConfig.open = false
      this.subscriptionViaSmsModalConfig.textKey = undefined
    },
  },
  computed: {
    isLoading() {
      if (this.stompClientForNotifications && this.stompClientForOnlineUsers) {
        if (this.stompClientForNotifications.connected && this.stompClientForOnlineUsers.connected) {
          this.doAsyncCallsAfterLoadingAllComponents();
          return true;
        } return this.initRefreshPage();
      }
      return false;
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    ...mapState('common', [
      'phoneShortcutEnabled',
      'homeScreenModalDisable',
      'multiOperatorInfo',
      'activeAddOnMiniGame',
      'verification',
      'modalForChallenge',
      'hideLeaderboard',
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'modalForHomePage',
      'hideStore',
      'chatEnabled',
      'hideWinners',
      'needLoad',
    ]),
    ...mapState('users', [
      'onlineUsers',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'challengePending',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'firstTimeEntry',
      'showThankYouEmailModal',
      'lanternGame',
      'notifications',
      'puzzleGame',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getTranslationByOperatorIfExists',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getMessagingConfig',
      'getInstallPromptEvent',
      'getIntegrationConfig',
      'isRegistrationViaSms',
    ]),
    numberOfUnreadNotifications() {
      return (this.notifications) ? this.notifications.filter(notification => !notification.readStatus).length : 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue